@defer (hydrate on immediate) {
	<div class="flex flex-col">
		<div class="relative">
			<div class="relative w-full z-[-999]">
				<img
					src="/assets/images/headers/desktop/header_ow_desktop.png"
					class="w-full h-[850px] object-cover hidden md:block"
					alt="Header Overwatch"
				/>
				<img
					src="/assets/images/headers/mobile/header_ow_mobile.png"
					class="w-full h-[850px] object-cover block md:hidden"
					alt="Header Overwatch"
				/>
			</div>
			<peps-separator></peps-separator>
		</div>
	</div>


	<div class="flex flex-col gap-20 mb-20">

		@if((members$ | async)?.length == 6) {
			<div class="flex-row justify-center mt-40 hidden 2xl:flex">
				@for(player of members$ | async; track player.id; let index = $index) {
					<peps-active-member-card
						[member]="player"
						[index]="index"
					></peps-active-member-card>
				}
			</div>
		}

		<div
			class="flex flex-row flex-wrap gap-8 mx-auto justify-center"
			[ngClass]="{'2xl:hidden': (members$ | async)?.length == 6, '2xl:flex': (members$ | async)?.length != 6}"
		>
			@for(player of members$ | async; track player.id) {
				<peps-member-card
					[member]="player"
				></peps-member-card>
			}
		</div>

		<div class="flex flex-row flex-wrap gap-8 mx-auto justify-center">
			@for(player of coachesSubstitutes$ | async; track player.id) {
				<peps-member-card
					[member]="player"
					[isSubstitute]="true"
				></peps-member-card>
			}
		</div>

		<div class="flex flex-col gap-10">

			<div class="flex flex-col md:flex-row justify-around items-center gap-4">
				<peps-title
					[subtitle]="'page.roster.leaderboard.subtitle' | translate"
					[title]="'page.roster.leaderboard.title' | translate"
				></peps-title>
				<span class="visible md:invisible"></span>
			</div>

			@if (faceItleaderboard().length > 0) {
				<div class="w-full md:w-3/4 lg:w-1/2 mx-auto overflow-x-auto custom-scrollbar">
					<table class="min-w-100 w-full text-sm font-notosans border-separate border-spacing-y-2">
						<thead>
						<tr class="text-peps-dark-200 uppercase text-xs">
							<td class="px-2 lg:px-6 py-1.5 lg:py-3 text-left">{{ 'page.roster.leaderboard.col-rank' | translate }}</td>
							<td class="px-2 lg:px-6 py-1.5 lg:py-3 text-left min-w-35">{{ 'page.roster.leaderboard.col-team' | translate }}</td>
							<td class="px-2 py-1.5 text-center">{{ 'page.roster.leaderboard.col-played' | translate }}</td>
							<td class="px-2 py-1.5 text-center text-green-500">{{ 'page.roster.leaderboard.col-won' | translate }}</td>
							<td class="px-2 py-1.5 text-center text-peps-red">{{ 'page.roster.leaderboard.col-lost' | translate }}</td>
							<td class="px-2 lg:px-6 py-1.5 lg:py-3 text-right">{{ 'page.roster.leaderboard.col-pts' | translate }}</td>
						</tr>
						</thead>
						<tbody>
							@for (entry of faceItleaderboard(); track entry.name; let i = $index) {
								<tr class="w-full bg-peps-dark-600 text-peps-dark-200/90"
								    [ngClass]="{ 'outline outline-peps-gold/40 drop-shadow-[0_0_8px_rgba(238,201,50,0.12)]': entry.name.toLowerCase().includes('peps') }">

									<td class="px-2 lg:px-6 py-1.5 lg:py-3 font-bold">
										<div class="flex flex-row items-center gap-1.5">
											@if (i === 0) { <span class="text-peps-gold">1</span> }
											@else if (i === 1) { <span class="text-peps-dark-200/70">2</span> }
											@else if (i === 2) { <span class="text-peps-brown">3</span> }
											@else { <span class="text-peps-dark-200/50">{{ i + 1 }}</span> }
											@if (entry.rankChange > 0) {
												<span class="flex flex-row items-center gap-0.5 text-green-500 text-xs font-normal">
													<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
														<path stroke-linecap="round" stroke-linejoin="round" d="M8.25 6.75 12 3m0 0 3.75 3.75M12 3v18" />
													</svg>
													{{ entry.rankChange }}
												</span>
											} @else if (entry.rankChange < 0) {
												<span class="flex flex-row items-center gap-0.5 text-peps-red text-xs font-normal">
													<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
														<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25 12 21m0 0-3.75-3.75M12 21V3" />
													</svg>
													{{ entry.rankChange * -1 }}
												</span>
											} @else {
												<span class="text-peps-dark-200/30 text-xs font-normal">—</span>
											}
										</div>
									</td>

									<td class="flex flex-row gap-4 items-center px-2 lg:px-6 py-3 lg:py-3 font-semibold"
									    [ngClass]="{ 'text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]': entry.name.toLowerCase().includes('peps') }">
										<img [src]="entry.avatar" [alt]="'Logo ' + entry.name" class="rounded-full h-8"/>
										<a class="relative w-fit" target="_blank" [href]="'https://www.faceit.com/fr/teams/' + entry.teamId + '/leagues'">
											{{ entry.name }}
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 absolute -top-1 -right-5">
												<path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
											</svg>
										</a>
									</td>

									<td class="px-2 py-1.5 text-center text-peps-dark-200">{{ entry.played }}</td>
									<td class="px-2 py-1.5 text-center text-green-500">{{ entry.won }}</td>
									<td class="px-2 py-1.5 text-center text-peps-red">{{ entry.lost }}</td>

									<td class="px-2 lg:px-6 py-3 text-right">
										<span class="text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)] text-lg">{{ entry.points }}</span>
										<span class="text-peps-dark-200/60 uppercase text-xs"> pts</span>
									</td>

								</tr>
							}
						</tbody>
					</table>
				</div>
			}
		</div>
		<peps-achievement-row
			[achievements]="achievements"
		></peps-achievement-row>

		<div class="flex flex-col gap-10">

			<div class="flex flex-col md:flex-row justify-around items-center gap-4">
				<peps-title
					[subtitle]="'page.home.upcoming-matches.subtitle' | translate"
					[title]="'common.matches.lowercase' | translate"
				></peps-title>
				<span class="visible md:invisible"></span>
			</div>

			<peps-upcoming-matchs
				[matches]="matches"
			></peps-upcoming-matchs>

		</div>

	</div>
	<peps-last-videos></peps-last-videos>
}
